import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { EnvironmentService } from './environment.service';
import { switchMap } from 'rxjs';
import { supplyContract } from '../interfaces/supplyContract';

@Injectable({
  providedIn: 'root'
})
export class SupplyContractService {

  /**
  * constructor
  * @param http 
  * @param environment 
  */
  constructor(
    private http: HttpClient,
    private environment: EnvironmentService) { }



  getContracts(publicId) {
    return this.environment.apiV1$.pipe(
      switchMap(url => this.http.get(`${url}/customer/${publicId}/contract`)
      )
    )
  }

  createContract(publicId,contract:supplyContract) {
    return this.environment.apiV1$.pipe(
      switchMap(url => this.http.post(`${url}/customer/${publicId}/contract`,contract)
      )
    )
  }


  editContract(publicId,contract:supplyContract) {
    return this.environment.apiV1$.pipe(
      switchMap(url => this.http.put(`${url}/customer/${publicId}/contract/${contract.number}`,contract)
      )
    )
  }


  deleteContracts(publicId) {
    return this.environment.apiV1$.pipe(
      switchMap(url => this.http.delete(`${url}/customer/${publicId}/contract`)
      )
    )
  }

}
